export const LOG_TABLES = {
    LOG: "api_log",
    ERROR: "api_error",
};

export const API_ENDPOINTS = {
    REWARD_PAGE: "/api/v1/json/landing-page/REWARD",
    INSTAMART_REWARD_PAGE: "/api/v1/json/landing-page/IM_REWARD",
    LOYALTY_EVALUATION: "/api/v2/view/evaluateScanAndEarn",
    AVAIL_DINE_CASH: "/api/v2/view/availScanAndEarn",
};

export const API_HOST = process.env.NEXT_PUBLIC_REWARD_PAGE_HOST || "https://disc.swiggy.com";
export const LOYALTY_API_HOST = process.env.NEXT_PUBLIC_LOYALTY_API_HOST || "https://dinersone-proxy.swiggy.com";

export const NR_EVENT_TYPES = {
    PAGE_VIEW_ERROR: "portal_gamification_frontend_page_view_error",
    PAGE_VIEW_SUCCESS: "portal_gamification_frontend_page_view_success",
};

export const ANALYTICS_HOST = "https://analytics.swiggy.com";

export enum BusinessCatagory {
    INSTAMART = "instamart",
}

export const NEW_RELIC_APPLICATION_ID = process.env.NEXT_PUBLIC_NEW_RELIC_APPLICATION_ID || "";

export const ADDITIONAL_API_HEADERS_FOR_PL_APIS = {
    "agent-type": "webview",
};
